import store from '@/store/store'
import userAgent from 'useragent'

export default function () {
  const device = { isSupported: true, noSupportTitle: '' }
  const ua = userAgent.parse(navigator.userAgent)
  if (ua.os.family === 'iOS' && !navigator.mediaDevices) {
    device.isSupported = false
    device.noSupportTitle = 'Please use Safari'
    device.noSupportSubtitle = 'Copy and paste the following link into Safari<br>ufc.com/connect'
  }
  if (ua.os.family === 'Android') {
    store.commit('gameplay/setTotalCaptures', 10)
    if (ua.family !== 'Chrome Mobile') {
      device.isSupported = false
      device.noSupportTitle = 'Please use Chrome'
      device.noSupportSubtitle = 'Copy and paste the following link into Chrome<br>ufc.com/connect'
    }
  }
  return device
}
